export enum Media {
  Min900 = "@media(min-width: 900px)",
  Min1200 = "@media(min-width: 1200px)",
}
